export default __webpack_public_path__ + "static/media/6.3d2179ac.jpg";